import React, { FC } from "react";
import { TierEditor } from "./TierEditor";
import { usePricing } from "./PricingContext";
import { DotLottleLoader } from "../../../components/Loader";

export const MatchingProductTiers: FC = () => {
    const { data, loading } = usePricing();
    if (loading || !data) return <DotLottleLoader />;
    return (
        <TierEditor
            title="Matching Product Tiers"
            resource="matching-product-tiers"
            minField="min_distinct_projects"
            minLabel="Min Distinct Project Sets"
            rows={data.matching_product_tiers}
        />
    );
};

export default MatchingProductTiers;
